import Button from "@mui/material/Button";
import { Add, Download } from "@mui/icons-material";
import localize from "../common/localize";
import FilterManager from "./common/FilterManager";
import useGlobalContext from "../hooks/useGlobalContext";
import { Box, CircularProgress } from "@mui/material";

export default function SearcherAndAdd({
  handleAddBtn,
  modal,
  hideAddButton,
  entityName,
  defaultFiltering,
  filterOptions,
  filterData,
  setFilterData,
  printButtonMethod,
  printButtonDisabled,
  isPrintLoading,
}) {
  const { basicFilterData, setBasicFilterData, basicFilterOptions } =
    useGlobalContext();
  return (
    <div
      className="flex gap-2 flex-wrap w-full items-center mt-1 justify-between"
      style={{ marginLeft: "16px", paddingRight: "16px" }}
    >
      <FilterManager
        filterDataValue={filterData ?? basicFilterData}
        setFilterDataValue={setFilterData ?? setBasicFilterData}
        defaultFilteringValue={defaultFiltering}
        filterOptionsValue={filterOptions ?? basicFilterOptions}
        filterItemNameValue={entityName}
      />

      <div className="flex flex-row gap-2 flex-wrap order-first sm:order-last">
        {!hideAddButton && (
          <div>
            <Button
              size="small"
              variant="contained"
              color="success"
              className="app_general_button_data app_success_button btn-sm"
              onClick={handleAddBtn}
            >
              <span className="mr-2">{localize.add}</span>
              <Add />
            </Button>
            <Box sx={{ height: "100%" }}>{modal}</Box>
          </div>
        )}

        {printButtonMethod && (
          <div>
            <Button
              disabled={printButtonDisabled}
              size="small"
              variant="contained"
              sx={{ backgroundColor: "#10366E" }}
              className="app_general_button_data btn-sm"
              onClick={printButtonMethod}
            >
              <span className="mr-2">{localize.export}</span>
              {!isPrintLoading ? (
                <Download />
              ) : (
                <CircularProgress style={{ width: "20px", height: "20px" }} />
              )}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
